<template>
  <div class="padding--LR24">
    <div class="padding--TB24">
      <el-form ref="parameterConfigForm" :model="formData" label-position="left">
        <el-row>
          <el-col v-for="item in paramItemList" :key="item.id" :span="24">
            <el-form-item
              :label="item.configName"
              label-width="280px"
              :prop="item.configKey"
              :rules="getItemRules(item)"
            >
              <template v-if="item.componentConfig">
                <component
                  :is="item.componentConfig.componentName"
                  v-bind="item.componentConfig.attribute"
                  v-model="formData[item.configKey]"
                >
                  <template v-if="item.componentConfig.componentName === 'el-select'">
                    <el-option
                      v-for="option in item.componentConfig.attribute.options"
                      :key="option.selectValue"
                      :label="option.displayValue"
                      :value="option.selectValue"
                    ></el-option>
                  </template>
                </component>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="paramItemList.length > 0" class="foot_b foot_b--padding text-center pos--sticky">
      <el-button class="self-button-width self-button-cancel">
        {{ $t('public.cancel') }}
      </el-button>
      <el-button
        class="self-button-width"
        :loading="saveLoading"
        type="primary"
        @click="saveConfig"
      >
        {{ $t('public.save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import parameterConfigApi from '@/api/parameter-config';
import { $isNullOrEmpty, $isEmpty } from '@/utils/helper';
export default {
  name: 'ParameterConfigItems',
  props: {
    templatedNode: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 开关类型（0），参数值类型（1），单项选择类型（2），多项选择类型（3）
      componentDefine: {
        0: {
          componentName: 'el-switch',
          attribute: {
            activeIconClass: 'el-icon-check'
          }
        },
        '1-0': {
          componentName: 'el-input-number',
          attribute: {
            controls: false,
            min: 0,
            precision: 0,
            placeholder: this.$t('public.pleaseEnter'),
            style: {
              width: '300px'
            }
          }
        },
        '1-1': {
          componentName: 'el-input',
          attribute: {
            placeholder: this.$t('public.pleaseEnter'),
            style: {
              width: '300px'
            }
          }
        },
        2: {
          componentName: 'el-select',
          attribute: {
            multiple: false,
            style: {
              width: '300px'
            }
          }
        },
        3: {
          componentName: 'el-select',
          attribute: {
            clearable: true,
            multiple: true,
            collapseTags: true,
            style: {
              width: '300px'
            }
          }
        }
      },
      paramItemList: [],
      paramItemValueList: [],
      formData: {},
      saveLoading: false
    };
  },
  created() {
    this.getModuleParamsById(this.templatedNode);
  },
  updated() {},
  methods: {
    // getParamsTemplate() {
    //   parameterConfigApi.getParamsTemplate().then(res => {
    //     if (res && res.data) {
    //       this.treeData = res.data || [];
    //       if (this.treeData.length === 0) { return; }
    //       this.currentNode = this.treeData[0];
    //       this.$nextTick(() => {
    //         this.$refs.tree.setCurrentKey(this.currentNode.id);
    //       });
    //       this.getModuleParamsById(this.currentNode);
    //       // this.getParamsValueByIdAndOrgId(this.currentNode);
    //     }
    //   });
    // },
    getModuleParamsById({ id }) {
      parameterConfigApi.getModuleParamsById({ id }).then(res => {
        if (res && res.data) {
          this.paramItemList = res.data.paramItemList.map(item => {
            let { configType } = item;
            if (configType == 1) {
              if (item.textType === 'number') {
                configType = '1-0';
              } else if (item.textType === 'text') {
                configType = '1-1';
              }
            }
            const componentConfig = JSON.parse(JSON.stringify(this.componentDefine[configType]));
            if (configType == 2) {
              componentConfig.attribute.options = item.selectContents;
              this.$set(
                this.formData,
                item.configKey,
                !$isEmpty(item.defaultValue) ? item.defaultValue : null
              );
            } else if (configType == 3) {
              componentConfig.attribute.options = item.selectContents;
              this.$set(
                this.formData,
                item.configKey,
                !$isEmpty(item.defaultValue) ? item.defaultValue.split(',') : []
              );
            } else if (configType == 0) {
              if (item.selectContents) {
                let falseValue;
                item.selectContents.forEach(switchItem => {
                  if (switchItem.displayValue === 'true') {
                    componentConfig.attribute.activeValue = switchItem.selectValue;
                  }
                  if (switchItem.displayValue === 'false') {
                    componentConfig.attribute.inactiveValue = switchItem.selectValue;
                    falseValue = switchItem.selectValue;
                  }
                });
                this.$set(
                  this.formData,
                  item.configKey,
                  (!$isEmpty(item.defaultValue) ? item.defaultValue: (falseValue || false))
                );
              }
            } else if (configType === '1-0') {
              this.$set(
                this.formData,
                item.configKey,
                !$isEmpty(item.defaultValue) ? Number(item.defaultValue) : undefined
              );
            } else {
              this.$set(this.formData, item.configKey, item.defaultValue || '');
            }
            return {
              ...item,
              componentConfig
            };
          });
          this.getParamsValueByIdAndOrgId({ id });
        }
      });
    },
    getParamsValueByIdAndOrgId({ id }) {
      // 此处暂时使用租户Id
      const { useOrgId } = this.$store.getters;
      parameterConfigApi.getParamsValueByIdAndOrgId({ templateId: id, useOrgId }).then(res => {
        if (res && res.data) {
          this.paramItemValueList = res.data;
          const itemValue = Object.assign({}, this.formData);
          this.paramItemValueList.forEach(item => {
            if (!$isNullOrEmpty(item.configValue)) {
              if (Array.isArray(itemValue[item.configKey])) {
                itemValue[item.configKey] = item.configValue.split(',');
              } else {
                itemValue[item.configKey] = item.configValue;
              }
            }
          });
          this.$set(this, 'formData', itemValue);
        }
      });
    },
    getItemRules({ configType, configName }) {
      const rule = { required: true };
      if (configType == 1) {
        rule.message = `${this.$t('public.pleaseEnter')}`;
        rule.trigger = 'blur';
      } else {
        rule.message = `${this.$t('public.pleaseSelect')}`;
        rule.trigger = 'change';
      }
      return [rule];
    },
    // 保存
    saveConfig() {
      // 先校验必填项
      this.$refs.parameterConfigForm.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          const data = [];

          // 对模板和值列表进行整合
          const aggregationParams = [...this.paramItemList, ...this.paramItemValueList];
          for (let i = 0; i < aggregationParams.length; i++) {
            let sameItem = null;
            for (let j = 0; j < data.length; j++) {
              if (data[j].configKey === aggregationParams[i].configKey) {
                sameItem = data[j];
                break;
              }
            }
            if (sameItem) {
              if (!sameItem.id && aggregationParams[i].id) {
                console.log(sameItem);
                sameItem.id = aggregationParams[i].id;
              }
            } else {
              data.push({
                id: aggregationParams[i].id || '',
                configKey: aggregationParams[i].configKey,
                configName: aggregationParams[i].configName,
                configValue: Array.isArray(this.formData[aggregationParams[i].configKey])
                  ? this.formData[aggregationParams[i].configKey].toString()
                  : this.formData[aggregationParams[i].configKey],
                parameterConfigTemplateId: this.templatedNode.id,
                useOrgId: this.$store.getters.useOrgId
              });
            }
          }
          parameterConfigApi
            .batchAddOrUpdate(data)
            .then(res => {
              this.saveLoading = false;
              if (res.success) {
                this.$message.success(this.$t('common.successText'));
              }
            })
            .catch(() => {
              this.saveLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pos--sticky {
  position: sticky;
  bottom: 0px;
  background-color: #fff;
  padding: 10px 0 10px;
}
</style>
